export { default } from './CDCProtegido25Condicoes';
